"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSupport = function SvgIconSupport(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "support icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Support Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42 26.997a6.739 6.739 0 00-4.5-6.358v-1.141a13.498 13.498 0 00-26.995 0v1.141a6.748 6.748 0 000 12.73 2.25 2.25 0 003-2.13V19.498a10.498 10.498 0 1120.996 0v11.741a2.24 2.24 0 00.75 1.65v.852c0 2.21-1.936 3-3.75 3h-2.666a2.999 2.999 0 100 3h2.667c3.973 0 6.749-2.468 6.749-6v-.717A6.75 6.75 0 0042 26.997z"
  }));
};

var _default = SvgIconSupport;
exports.default = _default;